import Component from "@tunnel-components/@pages/administration/versionning/component";
import * as React from "react";
import { connect } from "react-redux";
import { VersionningActionCreator } from "@tunnel-store/index";
import * as Lodash from "lodash";
/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name
 * @name componentWillReceiveProps
 * @name render
 * @infos "https://reactjs.org"
 */
class Container extends React.PureComponent<any, any> {
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @description : possède des informations sur le composant
     * @property { object }       state
     * @property { boolean }      state.errorserver
     * @property { object }      state.versionning
     * ......
     */
    this.state = {
      errorserver: false,
      versionning: {},
    };
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState({ loading: true });
    this.props
      .VersionningActionCreator()
      .then(() => this.setState((state: any) => ({ loading: false })));
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** Comparaison des props */
    }
    if (nextProps.versionning !== this.props.versionning) {
      {
        /** Vérification de l'existence d'une variable */
      }
      if (!Lodash.isUndefined(nextProps.versionning)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any) => ({ versionning: nextProps.versionning }));
      }
      {
        /** Comparaison des props */
      }
    } else if (nextProps.serverError !== this.props.serverError) {
      {
        /** Vérification de l'existence d'une variable */
      }
      if (!Lodash.isUndefined(nextProps.serverError)) {
        this.setState((state: any) => ({ errorserver: true }));
      }
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return <Component {...this.state} {...this.props} />;
  }
}
/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  return {
    serverError: state.Versionning.error,
    versionning: state.Versionning.data,
  };
}

{
  /** exporter le HOC : connect */
}
export default connect(mapStateToProps, { VersionningActionCreator })(
  Container
);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/administration/versionning/container.tsx